import React, { useCallback } from "react";
import classes from "./Header.scss";
import {
  Dropdown,
  DropdownMenu,
  FilterLabelButtonV2,
  PageHeader,
} from "@toddle-edu/ds-web";

import { ToddleColored } from "@toddle-edu/ds-icons";
import _ from "lodash";

const Header = props => {
  const {
    title = "Create Post",
    onBackClick = () => {},
    headerRightComponent,
    isGlobalHeaderEnabled,
    showCurriculumDropdown = false,
    curriculumProgramData = [],
    setSelectedCurriculumProgramId,
    selectedCurriculumProgramId,
    setupCurriculumProgramDependencies,
    setSelectedCourseId,
    setSelectedCourse,
  } = props;

  const changeCurriculumProgram = useCallback(
    ({ key }) => {
      _.isFunction(setSelectedCurriculumProgramId) &&
        setSelectedCurriculumProgramId(key);
      _.isFunction(setupCurriculumProgramDependencies) &&
        setupCurriculumProgramDependencies({
          curriculumProgramIdPath: key,
        });
      _.isFunction(setSelectedCourseId) && setSelectedCourseId(null);
      _.isFunction(setSelectedCourse) && setSelectedCourse("ALL");
    },
    [setSelectedCurriculumProgramId]
  );

  return isGlobalHeaderEnabled ? (
    <PageHeader dsVersion="2.0">
      <PageHeader.Left
        icon={<ToddleColored size={"small"} />}
        onBackClick={onBackClick}
        title={title}
        testId="journal-postcreation"
      />
      {headerRightComponent ? (
        <PageHeader.Right>
          <div className={classes.headerRightContainer}>
            {headerRightComponent}
          </div>
        </PageHeader.Right>
      ) : null}
    </PageHeader>
  ) : (
    <PageHeader dsVersion="2.0">
      <PageHeader.Left
        icon={<ToddleColored size={"small"} />}
        onBackClick={onBackClick}
        title={title}
        testId="journal-postcreation"
        titleSuffix={
          showCurriculumDropdown ? (
            <Dropdown
              isSearchEnabled={true}
              dsVersion="2.0"
              overlay={
                <DropdownMenu
                  isSearchEnabled={true}
                  options={curriculumProgramData}
                  onClick={changeCurriculumProgram}
                  selectionType="tick"
                  value={selectedCurriculumProgramId}
                  dsVersion="2.0"
                  showSelection={true}
                />
              }
            >
              <div className={classes.curriculumDropdown}>
                <FilterLabelButtonV2
                  label={
                    _.find(curriculumProgramData, {
                      key: selectedCurriculumProgramId,
                    })?.label
                  }
                  type="plain"
                  className={classes.curriculumDropdownButton}
                  variant="neutral"
                />
              </div>
            </Dropdown>
          ) : null
        }
      />
      {headerRightComponent ? (
        <PageHeader.Right>
          <div className={classes.headerRightContainer}>
            {headerRightComponent}
          </div>
        </PageHeader.Right>
      ) : null}
    </PageHeader>
  );
};

export default Header;
